import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "use"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
const Pre = props => {
  const {
      className,
      use
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("pre", Object.assign({}, rest, {
    className: classNames(className, use === 'code' && 'private-pre--code')
  }));
};
Pre.propTypes = {
  use: PropTypes.oneOf(['default', 'code'])
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
Pre.defaultProps = {
  use: 'default'
};
Pre.displayName = 'Pre';
export default Pre;